<template>
    <!-- <NuxtLink :to="localePath(`/texty/${knihaKod}/${temaKod}`)">
        <span class="uap02-odkaz" v-html="formattedHtml" />
    </NuxtLink> -->
    <span
        v-if="parts.length > 1"
        class="uapz10"
    >
        <span
            v-if="stringStart !== formattedHtml"
            class="whitespace-nowrap"
            v-html="stringStart"
        />
        <template v-if="formattedHtml.includes('(')">&nbsp;</template>
        <template
            v-for="(part, i) in parts"
            :key="i"
        >
            {{ i === 0 ? "" : "&nbsp;/&nbsp;"
            }}<NuxtLink
                :to="localePath(`/mapy/atlas?service[]=${part.skupina_vrstev}`)"
            >
                {{ part.origin }}
            </NuxtLink>
        </template>
        <template v-if="formattedHtml.includes(')')">)</template>
    </span>
    <NuxtLink
        v-else
        :to="localePath(`/mapy/atlas?service[]=${parts[0]?.skupina_vrstev}`)"
    >
        <span class="uapz10">
            <span
                v-if="stringStart !== formattedHtml"
                class="whitespace-nowrap"
                v-html="stringStart + '&nbsp;'"
            /><template v-if="formattedHtml.includes('(')">&nbsp;</template
            >{{ parts[0]?.origin
            }}<template v-if="formattedHtml.includes(')')">)</template>
        </span>
    </NuxtLink>
</template>

<script lang="ts" setup>
const localePath = useLocalePath()
const { locale } = useI18n()
const props = defineProps<{
    html: string
}>()

const formattedHtml = props.html.replace(
    /<span class="(uapz10)">(.*?)<\/span>/g,
    "$2"
)
//const stringStart = formattedHtml.split(/ \d/)[0]?.replace(/\s/g, "&nbsp;")
const stringStart = formattedHtml
    .split(/( \d| O\.)/)[0]
    ?.replace("", "<i class='pi pi-arrow-right text-sm'></i>")
    ?.replaceAll("🡪", "<i class='pi pi-arrow-right text-sm'></i>")

// const kod = formattedHtml.match(/(Výkres O.|Drawing )\d{1}/g)?.join("")
const kod = formattedHtml.match(/\d\.?( ?(\/|,) ?)?/g)?.join("")
/* const temaKod =
    kod?.split(".").length === 4 ? kod?.split(".").slice(1).join(".") : kod
const knihaKod =
    kod?.split(".").length === 4
        ? kod?.split(".")[0]
        : (route.params.kody as string[])[0] */

type Code = {
    origin: string
    skupina_vrstev: string
}
const parts = ref<Code[]>([])
const codes = kod?.split(/ ?(\/|,) ?/g)
codes?.forEach(code => {
    if (code === "/") return
    parts.value.push({
        origin: locale.value === "cs" ? "O." + code : code,
        skupina_vrstev: "vykres_uap_o" + code,
    })
})
</script>

<style scoped></style>
